import React from "react";
import { connect } from "react-redux";

import "../../styles/send-enquiry.css";
import { lms_updateCurrentModal } from "../../actions";
import ModalConductor from "./ModalConductor";
import "./index.css";

const SendEnquiry = props => {
  return (
    <div id="lms-container">
      <div
        className="ask-query filter__buttons__tertiary"
        onClick={() => props.currentModal("ASK_QUESTION")}
      >
        <span>Send Enquiry</span>
      </div>
      <ModalConductor {...props.sendEnquiry} hideModal={() => props.currentModal("")} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    sendEnquiry: state.sendEnquiry
  };
};

const mapDispatchToProps = dispatch => {
  return {
    currentModal: modal => dispatch(lms_updateCurrentModal(modal))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SendEnquiry);
